<template>
  <section>
    <VueSlickCarousel v-bind="settings" class="carouselContainer">
      <slot name="default"></slot>
    </VueSlickCarousel>
  </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: {
    VueSlickCarousel,
  },
  props: {
    numberOfSlides: Number,
    wantArrows: Boolean,
    autoplay: Boolean,
  },
  data() {
    return {
      settings: {
        arrows: this.wantArrows===false ? this.wantArrows : true,
        edgeFriction: 0.35,
        autoplay: this.autoplay ? this.autoplay: false,
        autoplaySpeed: 4000,
        adaptiveHeight: true,
        infinite: true,

        slidesToShow: this.numberOfSlides ? this.numberOfSlides : 4,
        slidesToScroll: this.numberOfSlides ? this.numberOfSlides : 4,
        responsive: [
          {
            breakpoint: 1921,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
            },
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 1265,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 770,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
.slick-next:before, .slick-prev:before{
  color: #ffffff;
}

.slick-list{
  margin: 0 -10px;
  .slick-track{
    display: flex;
    margin-left: unset;
  }
  .slick-slide{
    margin: 0 10px;
  }
}
</style>